import { useEffect, useMemo } from "react";

import { type ContentGateRestriction, COOKIE_NAMES, removeCookie, setCookie } from "@jti/fe-common";

import { useContentGateRestrictions } from "../ContentGate/hooks/useContentGateRestrictions";
import { ContentGatePopup, type ContentGatePopupProps } from "../ContentGatePopup";

type HardContentGateProps = ContentGatePopupProps & { titleWhileEvaluating: string };

export const HardContentGate = (props: HardContentGateProps) => {
  const options = useMemo(
    () => ({
      onRestrictionViolated: (restriction: ContentGateRestriction) => {
        const coockieName = restriction.type ? COOKIE_NAMES[restriction.type]?.(restriction) : undefined;
        if (coockieName) {
          removeCookie(coockieName);
        }
      },
      onRestrictionPassed: (restriction: ContentGateRestriction) => {
        const coockieName = restriction.type ? COOKIE_NAMES[restriction.type]?.(restriction) : undefined;
        if (coockieName) {
          setCookie(coockieName, true, "/");
        }
      },
    }),
    []
  );

  const { activeRestrictions, isEvaluating } = useContentGateRestrictions(props.restrictions, options);

  useEffect(() => {
    const doneEvaluating = isEvaluating === false;
    const noRestrictionsViolated = activeRestrictions.length === 0;

    if (noRestrictionsViolated && doneEvaluating) {
      window.location.reload();
    }
  }, [isEvaluating, activeRestrictions]);

  return (
    <ContentGatePopup
      {...props}
      title={isEvaluating ? props.titleWhileEvaluating : props.title}
      restrictions={isEvaluating ? [] : activeRestrictions}
      isOpen={true}
    />
  );
};
